const endpoint = "https://nepb.cuba-go.com"
const cpoint = "https://central-backend.cuba-go.com"

const mediapoint = `${endpoint}`
const startpoint = `${cpoint}/nep/`

export { endpoint, mediapoint, startpoint }
